import { LitElement } from 'lit';
import { unsafeStatic, html } from "lit/static-html.js";
import { i18n } from '@lingui/core';
import { messages as nbMessages} from '../src/raw/cabin/locales/nb/messages.mjs';
import { messages as enMessages} from '../src/raw/cabin/locales/en/messages.mjs';
import { messages as fiMessages} from '../src/raw/cabin/locales/fi/messages.mjs';
import { messages as daMessages} from '../src/raw/cabin/locales/da/messages.mjs';
import { messages as svMessages} from '../src/raw/cabin/locales/sv/messages.mjs';
import { activateI18n } from '../src/utils/i18n';
activateI18n(enMessages, nbMessages, fiMessages, daMessages, svMessages);


export class IconCabin42 extends LitElement {
  render() {
      const title = i18n.t({ message: `Vacation cabin`, id: 'icon.title.cabin', comment: 'Title for cabin icon' });
      
      return html`<svg xmlns="http://www.w3.org/2000/svg"width="42"height="28"fill="none"viewBox="0 0 42 28" part="w-icon-cabin-42-part">${unsafeStatic(`<title>${title}</title>`)}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m18.326 3.828 1.769 1.815 1.769-1.815M2.904 26.071h36.19M5.62 14v12.071M20.095 14v12.071m-4.524 0v-6.5a.917.917 0 0 0-.905-.928h-3.619c-.5 0-.904.416-.904.928v6.5M2.904 15.857 12.857 7.5l9.952 8.357m11.763-1.393 2.714 5.107H26.429l2.714-5.107h-2.714l3.347-5.571h-2.714l4.795-6.965 4.977 6.965h-2.715l3.167 5.571H34.57Zm-2.715 5.107v6.5"></path></svg>`; }
}
if (!customElements.get('w-icon-cabin-42')) {
  customElements.define('w-icon-cabin-42', IconCabin42);
}